export const ELK_STACK_CONSTANTS = {
  title: "Streamline Observability with the Elastic Stack",
  subTitle: "Powerful Logging, Monitoring, and Visualization—Made Simple",
  text: "Leverage the full potential of OneMind's Hosted Elastic Stack to collect, process, analyze, and visualize your application and infrastructure logs with minimal overhead. Combine Beats, Fluentd, and Logstash with Elasticsearch, Kibana, and optional tools for a seamless observability experience.",
};
